import { defineComponent as _defineComponent } from 'vue'
import { OzDropdownButtonColorScheme } from '@@/library/v4/components/OzDropdownButton.vue'
import OzIconButton, { OzIconButtonColorScheme } from '@@/library/v4/components/OzIconButton.vue'
import LocaleSelector from '@@/vuecomponents/LocaleSelector.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthBottomNav',
  setup(__props) {


return { __sfc: true,OzDropdownButtonColorScheme, OzIconButton, OzIconButtonColorScheme, LocaleSelector }
}

})